<section class="upload-area" ng2FileDrop [uploader]="uploader" (onFileDrop)="fileDropOver($event, 'newPost')">
  <div class="row new-post">
    <div class="address-bars column medium-12">
      <div class="row address-bar-1">
        <div class="column medium-12 address-bar-inputs" style="color: #5376E3; font-size: 20px;text-transform: capitalize;">
          What's On Your Mind?
        </div>
      </div>
    </div>

    <div class="column medium-12">
      <div class="row new-post-body">
        <div class="column medium-12">
          <div class="post-fr">
            <div class="post-textarea" id="newPostTextArea" #newPostEditor [froalaEditor]="editorOptions" [(froalaModel)]="newPost.message" placeholder= 'Compose Message ...' rows="3"></div>
          </div>
          <div class="postAttachment" *ngIf="postUploadResp.length > 0">
            <div class="row">
              <div class="column medium-4" *ngFor="let attachment of postUploadResp;">
                <div class="row">
                  <div class="column medium-10 commonColor2 pointer" attr.title="{{attachment.name}}">
                    <div class="attachment_name">{{attachment.name}}</div>
                  </div>
                  <div class="column medium-2">
                    <i class="icon ion-ios-trash commonColor2" (click)="deleteAttachment(attachment.id)"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="documentsData.length>0">
            <div class="row">
              <div class="column medium-6 email-attachments" *ngFor="let document of documentsData">
                <div class="row">
                  <div class="column medium-10 commonColor2 pointer" attr.title="{{document['file'].name}}">
                    <div class="attachment_name">{{document['file'].name}}</div>
                  </div>
                  <div class="column medium-2" (click)="removeDocument(document)">
                    <i class="icon ion-ios-trash commonColor2"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="badge-dropdown create-post-footer">
            <div class="post-footer post-footer-left commonColor3">
              <div class="formatter-menu float-left"></div>

              <div class="float-left">
                <label for="nativeFileUpload" class="upload_button">
                  <i class="material-icons custom-icons">attach_file</i>
                </label>
                <input type="file" id="nativeFileUpload" (change)="startUpload($event, 'newPost')" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader" multiple/>
              </div>
              <div class="float-right text-right" (click)="createPost()"><button class="button small post-button">POST</button></div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</section>
